import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import {i18n} from '@/i18n'

import './plugins/index'
import ( /* webpackChunkName: "chunk-vendors-common" */ './plugins/commonPlugins/index' )

Vue.config.productionTip = false

Vue.http.headers.common['Timezone'] = Vue.prototype.$moment.tz.guess();

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
